import { displayModal } from '@growtype-chat/partials/actions/displayModal';

async function handleAjaxError(response, submitBtn = null) {
    if (submitBtn) {
        const $btn = jQuery(submitBtn);
        $btn.removeClass('is-loading');
        $btn.removeClass('is-playing');
    }

    if (response.statusText === 'abort' || response.status === 0) {
        return;
    }

    if (response?.responseJSON?.data?.message) {
        window.growtypeModal?.hideAll();

        const data = response.responseJSON.data;

        if (data.message === 'custom') {
            $('#growtypeChatCustomModal').find('.modal-body').html(data.modal_body);
            $('#growtypeChatCustomModal').modal('show');
        } else {
            displayModal(response);
        }
    }
}

export { handleAjaxError };
